// import axiosInstance from "./axiosInstance";
// export const registerMerchant = async (payload) => {
//   try {
//     const response= await axiosInstance.post("/api/auth/register", payload);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };
// export const logoutMerchantUser = async () => {
//   try {
//     const response= await axiosInstance.post("/api/auth/marchant/logout");
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };
// export const KycMerchant = async (userName,payload) => {
//   try {
//     const response= await axiosInstance.put(`/api/auth/kyc/user/${userName}`, payload);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };
// export const UpdateMarchantDetails = async (id,payload) => {
//   try {
//     const response= await axiosInstance.put(`/api/auth/update-user/marchant/${id}`, payload);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };
// export const updateMarchantPassword = async (id,payload) => {
//   try {
//     const response= await axiosInstance.put(`/api/auth/update-password/marchant/${id}`, payload);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };
// export const updateMarchantIamges = async (id, payload) => {
//   try {
//     const response = await axiosInstance.put(`/api/auth/update-user/merchant/${id}`, payload);

//     return {
//       success:response.data.success || true,
//       data: response?.data?.user, // ⚠ directly take user
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Failed To Update.",
//       status: error.response?.status || 500,
//     };
//   }
// };
// export const FinalMerchantActive = async (userName,payload) => {
//   try {
//     const response= await axiosInstance.put(`/api/auth/marchant/user-active/${userName}`, payload);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };


// export const getSingleMerchant = async (username) => {
//   try {
//     const response= await axiosInstance.get(`/api/auth/marchant/single-user/${username}`);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };


// export const getSingleMerchantStore = async (username) => {
//   try {
//     const response= await axiosInstance.get(`/api/auth/merchant/business/${username}`);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };

// export const postSingleMerchant = async (username,payload) => {
//   try {
//     const response= await axiosInstance.post(`/api/auth/merchant/business/${username}`,payload);
//    return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Faild To Create.",
//       status: error.response?.status || 500,
//     };
//   }
// };


// export const Login_User = async (payload) => {
//   try {
//     const response = await axiosInstance.post("/api/auth/login", payload);
//     return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "Login successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Login failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };




// export const VerifyUserMPin = async (payload) => {
//   try {
//     const response = await axiosInstance.post("/api/auth/verify/mpin", payload);
//     return {
//       success:response.data.success || true,
//       data: response.data?.data,
//       status: response.status,
//     };
//   } catch (error) {
//    return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Mpin  failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };

// export const forgetPassword = async (payload) => {
//   try {
//     const response = await axiosInstance.post("/api/auth/forget-pass", payload);

//     return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "Otp Send successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Login failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };

// export const verifyPassword = async (payload) => {
//   try {
//     const response = await axiosInstance.post("/api/auth/verify-otp", payload);

//     return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "Otp Send successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Login failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };


// export const resetPassword = async (payload) => {
//   try {
//     const response = await axiosInstance.post("/api/auth/reset-pass", payload);

//     return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "Otp Send successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Login failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };


// export const resetMpin = async (payload) => {
//   try {
//     const response = await axiosInstance.post("/api/auth/reset-mpin", payload);

//     return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "Otp Send successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Login failed. Please try again.",
//       status: error.response?.status || 500,
//     };
//   }
// };

// export const admin_UserList = async (params={}) => {
//   try {
//     const response = await axiosInstance.get("/api/admin/all/user/list",{
//       params:params
//     });

//     return {
//       success:response.data.success || true,
//       data: response?.data?.data,
//       message: response?.data?.message || "successful",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Server Error",
//       status: error.response?.status || 500,
//     };
//   }
// };

// export const getMyKycDetails = async () => {
//   try {
//     const response = await axiosInstance.get(
//       "/api/auth/kyc/me"
//     );

//     return {
//       success: response?.data?.success ?? true,
//       data: response?.data?.data,
//       message:
//         response?.data?.message ||
//         "KYC details fetched successfully",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Failed to fetch KYC details.",
//       status: error.response?.status || 500,
//     };
//   }
// };

// export const editMyKycDetails = async (payload) => {
//   try {
//     const response = await axiosInstance.put(
//       "/api/auth/kyc/me",
//       payload
//     );

//     return {
//       success: response?.data?.success ?? true,
//       data: response?.data?.data,
//       message:
//         response?.data?.message ||
//         "KYC updated successfully",
//     };
//   } catch (error) {
//     return {
//       success: false,
//       message:
//         error.response?.data?.message ||
//         error.response?.data?.error ||
//         "Failed to update KYC.",
//       status: error.response?.status || 500,
//     };
//   }
// };

import axiosInstance from "./axiosInstance";
export const registerMerchant = async (payload) => {
  try {
    const response= await axiosInstance.post("/api/auth/register", payload);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};
export const logoutMerchantUser = async () => {
  try {
    const response= await axiosInstance.post("/api/auth/marchant/logout");
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};
export const KycMerchant = async (userName,payload) => {
  try {
    const response= await axiosInstance.put(`/api/auth/kyc/user/${userName}`, payload);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};
export const UpdateMarchantDetails = async (id,payload) => {
  try {
    const response= await axiosInstance.put(`/api/auth/update-user/marchant/${id}`, payload);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};
export const updateMarchantPassword = async (id,payload) => {
  try {
    const response= await axiosInstance.put(`/api/auth/update-password/marchant/${id}`, payload);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};
export const updateMarchantIamges = async (id, payload) => {
  try {
    const response = await axiosInstance.put(`/api/auth/update-user/merchant/${id}`, payload);

    return {
      success:response.data.success || true,
      data: response?.data?.user, // ⚠ directly take user
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed To Update.",
      status: error.response?.status || 500,
    };
  }
};
export const FinalMerchantActive = async (userName,payload) => {
  try {
    const response= await axiosInstance.put(`/api/auth/marchant/user-active/${userName}`, payload);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};


export const getSingleMerchant = async (username) => {
  try {
    const response= await axiosInstance.get(`/api/auth/marchant/single-user/${username}`);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};


export const getSingleMerchantStore = async (username) => {
  try {
    const response= await axiosInstance.get(`/api/auth/merchant/business/${username}`);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};

export const postSingleMerchant = async (username,payload) => {
  try {
    const response= await axiosInstance.post(`/api/auth/merchant/business/${username}`,payload);
   return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Faild To Create.",
      status: error.response?.status || 500,
    };
  }
};


export const Login_User = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/login", payload);
    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "Login successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};




export const VerifyUserMPin = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/verify/mpin", payload);
    return {
      success:response.data.success || true,
      data: response.data?.data,
      status: response.status,
    };
  } catch (error) {
   return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Mpin  failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const forgetPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/forget-pass", payload);

    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "Otp Send successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const verifyPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/verify-otp", payload);

    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "Otp Send successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const resetPassword = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/reset-pass", payload);

    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "Otp Send successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};


export const resetMpin = async (payload) => {
  try {
    const response = await axiosInstance.post("/api/auth/reset-mpin", payload);

    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "Otp Send successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Login failed. Please try again.",
      status: error.response?.status || 500,
    };
  }
};

export const admin_UserList = async (params={}) => {
  try {
    const response = await axiosInstance.get("/api/admin/all/user/list",{
      params:params
    });

    return {
      success:response.data.success || true,
      data: response?.data?.data,
      message: response?.data?.message || "successful",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Server Error",
      status: error.response?.status || 500,
    };
  }
};

export const getMyKycDetails = async () => {
  try {
    const response = await axiosInstance.get(
      "/api/auth/kyc/me"
    );

    return {
      success: response?.data?.success ?? true,
      data: response?.data?.data,
      message:
        response?.data?.message ||
        "KYC details fetched successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to fetch KYC details.",
      status: error.response?.status || 500,
    };
  }
};

export const editMyKycDetails = async (payload) => {
  try {
    const response = await axiosInstance.put(
      "/api/auth/kyc/me",
      payload
    );

    return {
      success: response?.data?.success ?? true,
      data: response?.data?.data,
      message:
        response?.data?.message ||
        "KYC updated successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to update KYC.",
      status: error.response?.status || 500,
    };
  }
};

// Logged-in user's own basic profile (name / phone / email).
// PAN, Aadhaar and role are never sent through this call.
export const updateMyProfile = async (payload) => {
  try {
    const response = await axiosInstance.put(
      "/api/auth/user/me",
      payload
    );

    return {
      success: response?.data?.success ?? true,
      data: response?.data?.data,
      message:
        response?.data?.message ||
        "Profile updated successfully",
    };
  } catch (error) {
    return {
      success: false,
      message:
        error.response?.data?.message ||
        error.response?.data?.error ||
        "Failed to update profile.",
      status: error.response?.status || 500,
    };
  }
};







